function AppFooterCopyright() {
  return (
    <div className="font-general-regular flex justify-center items-center text-center">
      <div className="text-lg text-ternary-dark dark:text-ternary-light">
        &copy; {new Date().getFullYear()}
        <h7 className=" ml-1 duration-500">Aryeswara Litang Eka Kusuma</h7>.
      </div>
    </div>
  );
}

export default AppFooterCopyright;
